<template>
  <div class="filter-sort" :class="{ lander: isLander }">
    <div v-if="isLander" class="instruction">
      <slot name="instruction" />
    </div>
    <div v-else class="filter">
      <select class="sml" :value="filter.depart" @input="updateFilterDepart($event.target.value)">
        <option value="">All times</option>
        <option value="morning">12am to 12pm</option>
        <option value="afternoon">12pm to 6pm</option>
        <option value="evening">6pm to 12am</option>
      </select>
      <select class="sml" :value="filter.stops" @input="updateFilterStops($event.target.value)">
        <option value="">All stops</option>
        <option value="0">Nonstop</option>
        <option value="1">1 or fewer stops</option>
        <option value="2">2 or fewer stops</option>
      </select>
      <select class="sml" :value="filter.policy" @input="updateFilterPolicy($event.target.value)">
        <option :value="false">All prices</option>
        <option :value="true">In-policy only</option>
      </select>
      <div class="search">
        <input type="text" class="search sml" placeholder="Search airline name..." :value="filter.name" @input="updateFilterName($event.target.value)" />
      </div>
    </div>
    <div class="sort">
      <label>Sort by:</label>
      <select class="sml" :value="sort" @input="updateSort($event.target.value)">
        <option value="recommended">Recommended</option>
        <option value="shortest">Shortest</option>
        <option value="price-lowest">Price: lowest</option>
        <option value="price-highest">Price: highest</option>
        <option value="depart-earliest">Depart: earliest</option>
        <option value="depart-latest">Depart: latest</option>
        <option value="arrive-earliest">Arrive: earliest</option>
        <option value="arrive-latest">Arrive: latest</option>
      </select>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  filter: Object,
  sort: String,
  isLander: Boolean,
  isForceChaperoned: Boolean,
  showChaperoned: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(["update:filter", "update:sort"]);

const updateFilterDepart = val => {
  emit("update:filter", { depart: val, name: props.filter.name, policy: props.filter.policy, stops: props.filter.stops, type: props.filter.chaperoned });
};

const updateFilterName = val => {
  emit("update:filter", { depart: props.filter.depart, name: val, policy: props.filter.policy, stops: props.filter.stops, type: props.filter.chaperoned });
};

const updateFilterPolicy = val => {
  emit("update:filter", { depart: props.filter.depart, name: props.filter.name, policy: val, stops: props.filter.stops, type: props.filter.chaperoned });
};

const updateFilterStops = val => {
  emit("update:filter", { depart: props.filter.depart, name: props.filter.name, policy: props.filter.policy, stops: val, type: props.filter.chaperoned });
};

const updateSort = val => {
  emit("update:sort", val);
};
</script>

<style lang="less">
#flights {
  .filter-sort {
    margin-bottom: 2rem;

    input,
    select {
      margin-bottom: 1rem;
      width: 100%;
    }
  }
}

@media screen and (min-width: 60em) {
  #flights {
    .filter-sort {
      display: flex;
      align-items: center;
      gap: 1rem;

      input,
      select {
        margin-bottom: 0;
        width: auto;
      }
    }

    .filter,
    .instruction {
      display: flex;
      align-items: center;
      min-width: 0;
    }

    .filter {
      select {
        margin-right: 1rem;
      }
    }

    .sort {
      align-items: center;
      display: flex;
      margin-left: auto;

      label {
        margin: 0 0.5rem 0 0;
      }
    }
  }
}
</style>
